import React from 'react';
import ReactDOM from 'react-dom';
import Page from './layouts/Page.jsx';
import * as serviceWorker from './serviceWorker';
import './style/index.less';
import { auth } from '@api/login';
import bus from '@utils/bus';
import FrontendCache from 'indexdb-frontendcache';
window.$cache = new FrontendCache();


auth().then(res => {
    // console.log(res);
    bus.me = res.data;
    if(res.data.meta.errCode === 0){
        bus.userInfo = res.data.data.accountInfo
    } else {
        bus.me = null;
    }
    ReactDOM.render(<Page />, document.getElementById('root'));
});
// ReactDOM.render(<Page />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
